import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-nav.png'
import _imports_1 from '@/assets/img/ic_NavDropdown.svg'


const _withScopeId = n => (_pushScopeId("data-v-1400ac76"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full top-0 fixed bg-dashboard bg-cover flex items-center",
  style: {"z-index":"1"}
}
const _hoisted_2 = { class: "w-3/4 flex items-center py-5 mx-auto" }
const _hoisted_3 = { class: "flex-grow" }
const _hoisted_4 = {
  id: "user-menu",
  class: "cursor-pointer flex-none"
}
const _hoisted_5 = {
  id: "user-menu1",
  class: "rounded-full flex px-5 py-2 items-center space-x-3 bg-green-900"
}
const _hoisted_6 = { class: "overflow-hidden rounded-full w-8 h-8" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  id: "user-menu2",
  class: "text-white text-xs cursor-pointer"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "user-menu3",
  src: _imports_1,
  class: "",
  alt: ""
}, null, -1))
const _hoisted_10 = {
  class: "relative mt-10",
  style: {"display":"none"},
  id: "nav-menu"
}
const _hoisted_11 = {
  class: "w-60 bg-white p-1 absolute z-40 right-2 rounded shadow-box",
  id: "nav-menu-1"
}
const _hoisted_12 = {
  class: "flex items-center m-1 pb-2 border-b border-lime",
  id: "nav-menu-2"
}
const _hoisted_13 = {
  class: "flex-none w-12 h-12",
  id: "nav-menu-3"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  class: "flex-grow pl-2",
  id: "nav-menu-5"
}
const _hoisted_16 = {
  id: "nav-menu-6",
  class: "text-gray-700 font-bold text-xs"
}
const _hoisted_17 = {
  id: "nav-menu-8",
  class: "w-full border-b pb-1 border-lime"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "nav-menu-10",
  class: "flex-none",
  src: "/img/myle/svg/ic_logout.svg",
  alt: ""
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "nav-menu-12",
  class: "w-full text-gray-400 mx-auto px-1"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    id: "nav-menu-13",
    class: "cursor-default text-xs font-extralight"
  }, " MYLE Manager © 2026 ")
], -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "h-9 sm:mx-2",
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.navigateToEvents && _ctx.navigateToEvents(...args))),
          alt: ""
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              id: "user-menu-0",
              class: "w-full h-full object-cover rounded-full",
              src: _ctx.currentUserPicure || '@/assets/img/user.jpeg',
              alt: ""
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.currentUser.fullName || 'Guest'), 1),
          _hoisted_9
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                id: "nav-menu-4",
                src: 'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/' + _ctx.currentUser.profilePicture,
                class: "w-full h-full object-cover rounded-full",
                alt: ""
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, _toDisplayString((_ctx.currentUser && _ctx.currentUser.fullName) ? _ctx.currentUser.fullName : 'Guest'), 1),
              _createElementVNode("a", {
                id: "nav-menu-7",
                class: "break-all text-gray-700 font-light text-xs cursor-pointer transition duration-500 ease-in-out hover:text-lime",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.warning && _ctx.warning(...args)))
              }, _toDisplayString(_ctx.currentUser.email), 1)
            ])
          ]),
          _createElementVNode("ul", _hoisted_17, [
            _createElementVNode("li", {
              id: "nav-menu-9",
              class: "w-full flex cursor-pointer transition duration-500 ease-in-out items-center p-3 hover:bg-gray-150 rounded",
              onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.navigateToLogin && _ctx.navigateToLogin(...args)))
            }, [
              _hoisted_18,
              _createElementVNode("p", {
                id: "nav-menu-11",
                class: "flex-grow px-4 text-sm text-gray-500",
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.navigateToLogin && _ctx.navigateToLogin(...args)))
              }, "Logout")
            ])
          ]),
          _hoisted_19
        ])
      ])
    ])
  ]))
}